import { Subscription } from 'rxjs';
import { Component, OnInit, ViewEncapsulation, HostListener, Output, EventEmitter, OnDestroy, TemplateRef, ViewChild, Input, ElementRef } from '@angular/core';
import { ActionMenuService } from './action-menu.service';
import { MediasQueryService } from '../../services/medias-query.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Component({
    selector: 'app-action-menu',
    templateUrl: './action-menu.component.html'
})
export class ActionMenuComponent implements OnInit, OnDestroy {

    @Output() close = new EventEmitter<any>();
    @Input() classIcon: string;
    @Input() id;

    model: any = {};
    mediasQuerySubscription: Subscription;

    @HostListener('click', ['$event'])
    public onClick(event: any): void {
        event.stopPropagation();
        event.preventDefault();
    }

    @Output()
    appClickOutside: EventEmitter<void> = new EventEmitter();

    @ViewChild(TemplateRef) template: TemplateRef<any>;

    constructor(
        private actionMenuService: ActionMenuService,
        private bottomSheet: MatBottomSheet,
        private mediasQueryService: MediasQueryService,
        private elem: ElementRef,
        private elementRef: ElementRef<HTMLElement>
    ) {
        this.closeListener();
    }

    ngOnInit() {

        this.mediasQuerySubscription = this.mediasQueryService.isMobile().subscribe(result => this.model.isMobile = result);
    }

    open() {
      event.preventDefault();
      if (this.model.isMobile) {

          const bottomRef = this.bottomSheet.open(this.template);

          bottomRef.afterDismissed().subscribe(result => {
              if (result) {
                  // this.changeItem(result);
              }
          });
      } else {
        const elementId = document.getElementById(this.id);
        const icon_ = document.getElementById("action-btn-icon_" + this.id);

          if (elementId.classList.contains("open")) {
            this.model.open = false;
            icon_?.classList?.remove("open");
            elementId?.classList?.remove("open");
          } else {
            this.actionMenuService.closeEvent.next(true);
            this.model.open = true;
            icon_?.classList?.add("open");
            elementId?.classList?.add("open");
          }
      }
    }

    closeListener() {
        this.actionMenuService.closeEvent.subscribe(() => {
            let elements = document.getElementsByClassName("action-options");

            let elements_icon = document.getElementsByClassName("action-icon");

            for (var i = 0, len = elements.length; i < len; i++) {
                elements[i].classList?.remove("open");
            }

            for (var i = 0, len = elements_icon.length; i < len; i++) {
                elements_icon[i].classList?.remove("open");
            }

            this.model.open = false;
            this.bottomSheet.dismiss();
        });
    }

    ngOnDestroy() {
        this.mediasQuerySubscription.unsubscribe();
    }
}
